module.exports = __webpack_public_path__ + "img/sample_img_phone_01.4ed0f9b1.png";